"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var icon_key_r_svg_1 = __importDefault(require("@assets/icons/icon_key_r.svg"));
var icon_key_a_svg_1 = __importDefault(require("@assets/icons/icon_key_a.svg"));
var icon_key_s_svg_1 = __importDefault(require("@assets/icons/icon_key_s.svg"));
var icon_key_enter_svg_1 = __importDefault(require("@assets/icons/icon_key_enter.svg"));
var icon_key_esc_svg_1 = __importDefault(require("@assets/icons/icon_key_esc.svg"));
var icon_key_right_svg_1 = __importDefault(require("@assets/icons/icon_key_right.svg"));
var icon_key_left_svg_1 = __importDefault(require("@assets/icons/icon_key_left.svg"));
var icon_key_up_svg_1 = __importDefault(require("@assets/icons/icon_key_up.svg"));
var icon_key_down_svg_1 = __importDefault(require("@assets/icons/icon_key_down.svg"));
var Modal_1 = __importDefault(require("@/react-app/common/components/Modal"));
function KeyboardModal(_a) {
    var setIsOpen = _a.setIsOpen, isOpen = _a.isOpen;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(Modal_1.default, { isOpen: isOpen, setIsOpen: setIsOpen, modalContentClassName: "custom-modal-style" },
        react_1.default.createElement("div", { className: "eva-keyboard-layout" },
            react_1.default.createElement("h2", null, t('MODERATION.QUEUE_VIEW.KEYBOARD_SHORTCUT_MODAL.TITLE')),
            react_1.default.createElement("p", null, t('MODERATION.QUEUE_VIEW.KEYBOARD_SHORTCUT_MODAL.TEXT')),
            react_1.default.createElement("table", { className: "table-striped" },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("th", null, t('MODERATION.QUEUE_VIEW.KEYBOARD_SHORTCUT_MODAL.TABLE.HEADER.ACTION')),
                    react_1.default.createElement("th", null,
                        " ",
                        t('MODERATION.QUEUE_VIEW.KEYBOARD_SHORTCUT_MODAL.TABLE.HEADER.KEY_COMMAND'))),
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", null, t('MODERATION.QUEUE_VIEW.KEYBOARD_SHORTCUT_MODAL.TABLE.ACTION_COLUMN.ACCEPT')),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("img", { src: icon_key_a_svg_1.default }))),
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", null, t('MODERATION.QUEUE_VIEW.KEYBOARD_SHORTCUT_MODAL.TABLE.ACTION_COLUMN.REFUSE')),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("img", { src: icon_key_r_svg_1.default }))),
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", null, t('MODERATION.QUEUE_VIEW.KEYBOARD_SHORTCUT_MODAL.TABLE.ACTION_COLUMN.SEND_TO_QUEUE')),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("img", { src: icon_key_s_svg_1.default }))),
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", null, t('MODERATION.QUEUE_VIEW.KEYBOARD_SHORTCUT_MODAL.TABLE.ACTION_COLUMN.CONFIRM_DECISION')),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("img", { src: icon_key_enter_svg_1.default }))),
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", null, t('MODERATION.QUEUE_VIEW.KEYBOARD_SHORTCUT_MODAL.TABLE.ACTION_COLUMN.CLEAR_SEARCH_BOX')),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("img", { src: icon_key_esc_svg_1.default }))),
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", null, t('MODERATION.QUEUE_VIEW.KEYBOARD_SHORTCUT_MODAL.TABLE.ACTION_COLUMN.GO_TO_NEXT_FIELD')),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("img", { src: icon_key_right_svg_1.default }))),
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", null, t('MODERATION.QUEUE_VIEW.KEYBOARD_SHORTCUT_MODAL.TABLE.ACTION_COLUMN.GO_TO_PREV_FIELD')),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("img", { src: icon_key_left_svg_1.default }))),
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", null, t('MODERATION.QUEUE_VIEW.KEYBOARD_SHORTCUT_MODAL.TABLE.ACTION_COLUMN.MOVE_UP')),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("img", { src: icon_key_up_svg_1.default }))),
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("td", null, t('MODERATION.QUEUE_VIEW.KEYBOARD_SHORTCUT_MODAL.TABLE.ACTION_COLUMN.MOVE_DOWN')),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("img", { src: icon_key_down_svg_1.default })))))));
}
exports.default = KeyboardModal;
